var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4226 3.57745C11.0972 3.25201 10.5695 3.25201 10.2441 3.57745C9.91864 3.90289 9.91864 4.43053 10.2441 4.75596L14.6548 9.16671H3.33333C2.8731 9.16671 2.5 9.5398 2.5 10C2.5 10.4603 2.8731 10.8334 3.33333 10.8334H14.6548L10.2441 15.2441C9.91864 15.5696 9.91864 16.0972 10.2441 16.4226C10.5695 16.7481 11.0972 16.7481 11.4226 16.4226L17.2559 10.5893C17.5814 10.2639 17.5814 9.73622 17.2559 9.41079L11.4226 3.57745Z",
    fill: "#DC1928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightThin);
export default __webpack_public_path__ + "static/media/arrow-right-thin.f8a30d50668676c4d73c41507ef781cd.svg";
export { ForwardRef as ReactComponent };